import {
  Box,
  CircularProgress,
  Grid,
  MenuItem,
  Modal,
  Select,
  TextField,
  Typography
} from '@mui/material'
import React, { useState } from 'react'
import CloseIcon from '@mui/icons-material/Close'
import useStyles from './useStyles'
import AddIcon from '@mui/icons-material/Add'
import { addAppVersionRTEnviroments } from '../../../app/services/versionEnviroments/addAppVersionRTEnviroments'
import { logEvent } from '../../../utils/LogEvents'
import {
  setErrorTextSnackBar,
  setRequestTextSnackBar,
  setSuccessTextSnackBar
} from '../../../redux/actions/app'
import { useDispatch } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import {
  featureFlagsAppPlatformCodes,
  featureFlagsAppCodes
} from '../../../utils/traducTypes'
import { getAppVersionRTEnviroments } from '../../../app/services/versionEnviroments/getAppVersionRTEnviroments'

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 550,
  height: 400,
  bgcolor: 'white',
  p: 3,
  borderRadius: '8px',
  boxShadow: '0px 0px 4px rgba(36, 55, 143, 0.4)'
}

export const AddVersionModal = ({ versions = [] }) => {
  const classes = useStyles()
  const [openModal, setopenModal] = useState(false)
  const [appVersionCode, setAppVersionCode] = useState('')
  const [detail, setdetail] = useState('')
  const [appCode, setappCode] = useState(featureFlagsAppCodes[0])
  const [appPlatformCode, setappPlatformCode] = useState(
    featureFlagsAppPlatformCodes[0].value
  )
  const [versionError, setversionError] = useState(false)
  const [versionErrorText, setversionErrorText] = useState('')
  const [showCircularProgress, setshowCircularProgress] = useState(false)

  const handleOpen = () => {
    setopenModal(true)
  }
  const handleChangeVersionCode = (e) => {
    setAppVersionCode(e.target.value)
  }

  const handleChangeDetail = (e) => {
    setdetail(e.target.value)
  }
  const handleChangeappCode = (e) => {
    setappCode(e.target.value)
  }
  const handleChangeappPlatformCode = (e) => {
    setappPlatformCode(e.target.value)
  }

  const dispatch = useDispatch()
  const navigate = useNavigate()

  const publishVersion = async () => {
    setversionError(false)
    setshowCircularProgress(true)
    if (!appVersionCode || appVersionCode === '') {
      setversionErrorText('Ingrese la nueva versión')
      setversionError(true)
      setshowCircularProgress(false)
      return
    }

    if (versions.length > 0) {
      const isVersionExist = versions.find(
        (version) => version.appPlataformCode === appPlatformCode && version.versions.find((item) => item.appVersionCode === appVersionCode)
      )

      if (isVersionExist) {
        setversionErrorText('La versión ya existe')
        setversionError(true)
        setshowCircularProgress(false)
        return
      }
    }
    try {
      const version = await getAppVersionRTEnviroments(appPlatformCode, true)
      const isDeprecatedVersionExist =
        version?.data?.data?.deprecatedVersions && version.data.data.deprecatedVersions.find(
          (item) => item.appVersionCode === appVersionCode
        )
      if (isDeprecatedVersionExist) {
        setversionErrorText('La versión fue deprecada')
        setversionError(true)
        setshowCircularProgress(false)
        return
      }

      const newversion = await addAppVersionRTEnviroments(
        appCode,
        appPlatformCode,
        appVersionCode,
        detail
      )
      logEvent('CGI - addAppVersionRTEnviroments', {
        body: {
          appCode,
          appPlatformCode,
          appVersionCode,
          appVersionDesc: detail
        },
        response: newversion
      })
      dispatch(setRequestTextSnackBar())
      dispatch(setSuccessTextSnackBar('Publicación exitosa'))
      setTimeout(() => {
        navigate(0)
      }, 1000)
    } catch (error) {
      dispatch(setRequestTextSnackBar())
      dispatch(setErrorTextSnackBar('Ocurrió un error al publicar la versión'))
    }
    setshowCircularProgress(false)
  }

  return (
    <>
      <div className={classes.buttonAddVersion} onClick={handleOpen}>
        <AddIcon style={{ color: '#008471' }} />
        <Typography className={classes.subtitle}>
          Publicar una nueva versión
        </Typography>
      </div>
      <Modal open={openModal} onClose={() => setopenModal(false)}>
        <Box sx={style}>
          <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
            <CloseIcon
              sx={{
                fontSize: 'medium',
                color: '#263057',
                cursor: 'pointer'
              }}
              onClick={() => setopenModal(false)}
            />
          </div>

          <div>
            <Typography
              sx={{ color: '#263057', fontSize: '1.3em', fontWeight: 'bold' }}
            >
              Publicar una nueva versión
            </Typography>
          </div>
          <Typography
            sx={{ color: '#263057', fontSize: '1.1em', marginTop: '1rem' }}
          >
            Ingrese los datos de la nueva versión
          </Typography>
          <Grid container style={{ marginTop: 10 }}>
            <Grid
              item
              xs={3}
              style={{
                display: 'flex',
                alignItems: 'center',
                paddingLeft: 10
              }}
            >
              <Typography sx={{ color: '#263057', fontSize: '1em' }}>
                Descripción:
              </Typography>
            </Grid>
            <Grid item xs={8}>
              <TextField
                autoFocus
                margin="dense"
                id="detail"
                type="text"
                value={detail}
                onChange={handleChangeDetail}
                placeholder={'Ej: Nuevas actualizaciones'}
                variant="standard"
                multiline
                maxRows={3}
                // error={error}
                // helperText={error ? errorText : ''}
                style={{ width: '100%' }}
              />
            </Grid>
            <Grid
              xs={3}
              item
              style={{
                display: 'flex',
                alignItems: 'center',
                paddingLeft: 10,
                paddingTop: 10
              }}
            >
              <Typography sx={{ color: '#263057', fontSize: '1em' }}>
                Versión:
              </Typography>
            </Grid>
            <Grid xs={8} item style={{ paddingTop: 10 }}>
              <TextField
                autoFocus
                margin="dense"
                id="versionCode"
                type="text"
                value={appVersionCode}
                onChange={handleChangeVersionCode}
                placeholder={'Ej: 1.0.0'}
                variant="standard"
                error={versionError}
                helperText={versionError ? versionErrorText : ''}
                style={{ width: '100%' }}
              />
            </Grid>

            <Grid
              xs={3}
              item
              style={{
                display: 'flex',
                alignItems: 'center',
                paddingLeft: 10,
                paddingTop: 10
              }}
            >
              <Typography sx={{ color: '#263057', fontSize: '1em' }}>
                Aplicación:
              </Typography>
            </Grid>
            <Grid item xs={8} style={{ paddingTop: 10 }}>
              {/* <FormControl
              variant="standard"
              className={classes.formControlStyle}
            > */}
              <Select
                labelId="demo-simple-select-filled-label"
                id="demo-simple-select-filled"
                value={appCode}
                onChange={handleChangeappCode}
                size="small"
              >
                {featureFlagsAppCodes.map((app) => (
                  <MenuItem key={app} value={app}>
                    {app}
                  </MenuItem>
                ))}
              </Select>
              {/* </FormControl> */}
            </Grid>
            <Grid
              item
              xs={3}
              style={{
                display: 'flex',
                alignItems: 'center',
                paddingLeft: 10,
                paddingTop: 10
              }}
            >
              <Typography sx={{ color: '#263057', fontSize: '1em' }}>
                Plataforma:
              </Typography>
            </Grid>
            <Grid item xs={8} style={{ paddingTop: 10 }}>
              <Select
                labelId="demo-simple-select-filled-label"
                id="demo-simple-select-filled"
                value={appPlatformCode}
                onChange={handleChangeappPlatformCode}
                size="small"
              >
                {featureFlagsAppPlatformCodes.map((plataform) => (
                  <MenuItem key={plataform.value} value={plataform.value}>
                    {plataform.title}
                  </MenuItem>
                ))}
              </Select>
            </Grid>
          </Grid>

          <Box className={classes.buttons} style={{ marginLeft: '45%' }}>
            <ButtonConfirm
              showCircularProgress={showCircularProgress}
              publishVersion={publishVersion}
            />
            <ButtonClose handleClose={() => setopenModal(false)} />
          </Box>
        </Box>
      </Modal>
    </>
  )
}
function ButtonConfirm ({ showCircularProgress, publishVersion }) {
  const classes = useStyles()

  return (
    <div style={{ position: 'relative', display: 'inline-block' }}>
      <button
        className={classes.confirmButton}
        onClick={publishVersion}
        disabled={showCircularProgress}
      >
        {showCircularProgress
          ? (
          <CircularProgress size="1.5rem" color="inherit" />
            )
          : (
          <Typography className={classes.confirmButtonTypography}>
            Publicar
          </Typography>
            )}
      </button>
    </div>
  )
}

function ButtonClose ({ handleClose }) {
  const classes = useStyles()

  return (
    <Box onClick={handleClose} className={classes.closeButton}>
      <Typography className={classes.closeButtonColor}>Cancelar</Typography>
    </Box>
  )
}
